export default "__VITE_ASSET__2fa59342__"